<template>
	<div class="nav-layout">
		<nav ref="navRef" class="nav-layout__nav-container">
			<NuxtLink :to="localePath('/')">
				<GlobalLogo />
			</NuxtLink>
			<ButtonUnderlined iconBefore="arrow-left" class="nav-layout__button" :to="localePath('/')">{{
				$t('layouts.nav.back_to_homepage')
			}}</ButtonUnderlined>
		</nav>
		<slot />
		<GlobalIntercomFacade />
	</div>
</template>

<script setup lang="ts">
const navRef = ref<HTMLElement | null>(null)
const navHeight = computed(() => {
	return navRef.value?.clientHeight
})

const localePath = useLocalePath()

provide('navHeight', navHeight)
</script>

<style lang="scss">
@import './nav';
</style>
